import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ContextMenu } from 'primeng/contextmenu';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { Button, ButtonModule } from 'primeng/button';
import { ContextMenuModule } from 'primeng/contextmenu';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ListboxModule } from 'primeng/listbox';
import { SelectModule } from 'primeng/select';
import { Table, TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TextareaModule } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { ConfirmationService, MessageService } from 'primeng/api';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment'; // <-- Import environment
import { Observable, Subject, takeUntil, forkJoin, of, catchError, map } from 'rxjs';
import { RoleAccessService } from '../auth/role-access.service';
import { UserRole } from '../auth/roles.enum';
import { AppFeature } from '../auth/features.enum';
import { InMemoryStorageService } from '../services/in-memory-storage.service';
import { LoaderService } from '../services/loader.service';
import { UserService } from '../pages/service/user.service';

interface User {
    id: number;
    firstName: string;
    middleName?: string;
    lastName: string;
    email: string;
    mobile: string;
    isActive: boolean;
    userName: string; // Added userName property
    status?: string;
    facility?: string;
    warehouse?: string;
    company?: string;
    division?: string;
    m3ResponsibleId?: string;

}

@Component({
    selector: 'app-registered-user',
    standalone: true,
    imports: [
        ListboxModule,
        CommonModule,
        TableModule,
        FormsModule,
        ButtonModule,
        ProgressSpinnerModule,
        RippleModule,
        ToastModule,
        ToolbarModule,
        RatingModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        RadioButtonModule,
        InputNumberModule,
        DialogModule,
        TagModule,
        InputIconModule,
        IconFieldModule,
        ConfirmDialogModule,
        ContextMenuModule,
        RouterModule,
        AutoCompleteModule
    ],
    templateUrl: './registered-user.component.html',
    styleUrls: ['./registered-user.component.scss'],
    providers: [ConfirmationService, MessageService]
})
export class RegisteredUserComponent implements OnInit, OnDestroy {
    allUsers: { id: number; userName: string }[] = [];
    goBack() {
        this.router.navigate(['/Orders1']);
    }

    assignRoleDialog = false;
    roleGroupSuggestions: any[] = [];
    selectedRoleGroups: any[] = [];
    // selectedUsers: any[] = []; // Make sure this is populated with selected users
    isLoadingRoles = false;
    registeredUsers: User[] = [];
    selectedUsers: User[] = [];
    private destroy$ = new Subject<void>();
    registerDialog: boolean = false;
    submitted: boolean = false;
    searchTerm: string = '';
    filteredUsers: User[] = [];
    allUsernames: string[] = []; // Store all usernames for validation
    usernameError: string = ''; // Error message for username validation
    registerData = {
        userName: '',
        middleName: '',
        firstName: '',
        lastName: '',
        email: '',
        countryCode: '+91', // Default to India

        mobileNumber: '',
        password: '',
        status: '',
        facility: '',
        warehouse: '',
        company: '', // Added company property
        division: '', // Added division property
        m3ResponsibleId: '' // Added m3Responsible property
    };
    reEnteredPassword: string = '';

    private userIdCounter = 1;
    editingUserId: number | null = null;
    usernameValid: string = '';
    mobileNumberError: string = ''; // Error message for mobile number validation
   
    canAccess = false;
    constructor(
        private confirmationService: ConfirmationService,
        private messageService: MessageService,
        private http: HttpClient, // <-- Inject HttpClient
        private router: Router, // <-- Inject Router
        private roleAccessService: RoleAccessService, // <-- Add this
        private loaderService: LoaderService, 
        private inmemoryStorageService: InMemoryStorageService, // <-- Inject InMemoryStorageService
        private userService: UserService
    ) {}
    navigateToRegisteredUser(): void {
        this.router.navigate(['/registered-user']);
    }

    ngOnInit(): void {
        // const userRoles: UserRole[] = JSON.parse(localStorage.getItem('roleGroup') || '[]');
        let userRoles = JSON.parse(this.inmemoryStorageService.get('roleGroup') || '[]');
        this.canAccess = this.roleAccessService.hasAccess(userRoles, AppFeature.UserManagement);
        console.log('Can Access User Management:', this.canAccess); // Log access permission for debugging

        if (this.canAccess) {
            this.fetchUsers();
        }
        else{
            this.router.navigate(['/Orders1']);
        }
    }

    fetchUsers(): void {
        this.loaderService.show('Loading users...');
        console.log('Loader state: true'); // Log when loader starts

        // Add a delay of 3 seconds to simulate a slower API response
        setTimeout(() => {
            this.http
                .get<User[]>(`${environment.authApiUrl}list`)
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                    next: (data) => {
                        if (data && data.length > 0) {
                            // Data fetched successfully
                            this.registeredUsers = data;
                            this.allUsers = data.map((user) => ({
                                id: user.id,
                                userName: user.userName
                            }));
                            this.inmemoryStorageService.set('allUsers', JSON.stringify(this.allUsers)); // Store all users in InMemoryStorageService

                            console.log(this.allUsers, 'allUsers');
                        } else {
                            // Successful response but no data
                            this.messageService.add({
                                severity: 'info',
                                summary: 'No Data',
                                detail: 'No registered users found.',
                                life: 3000
                            });
                        }
                        this.loaderService.hide(); // Stop the loader
                        console.log('Loader state: false'); // Log when loader stops
                    },
                    error: (err) => {
                        // API call failed
                        console.error('Failed to fetch users:', err);
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Failed to fetch registered users.',
                            life: 3000
                        });
                        this.loaderService.hide(); // Stop the loader
                        console.log('Loader state: false'); // Log when loader stops
                    }
                });
        }, 3000); // 3 seconds delay
    }

    openRegisterDialog(): void {
        this.submitted = false;
        this.registerDialog = true;
        this.editingUserId = null;
        this.registerData = {
            firstName: '',
            lastName: '',
            email: '',
            mobileNumber: '',
            password: '',
            countryCode: '+91', // Default to India

            userName: '',
            middleName: '',
            status: '',
            facility: '',
            warehouse: '',
            company: '', // Added company property
            division: '', // Added division property
            m3ResponsibleId: '' // Added m3Responsible property
        };
        this.reEnteredPassword = '';
    }

    hideDialog(): void {
        this.registerDialog = false;
        this.submitted = false;
        this.editingUserId = null;
        this.registerData = {
            firstName: '',
            lastName: '',
            email: '',
            mobileNumber: '',
            password: '',
            countryCode: '+91', // Default to India

            userName: '',
            middleName: '',
            status: '',
            facility: '',
            warehouse: '',
            company: '', // Added company property
            division: '', // Added division property
            m3ResponsibleId: '' // Added m3Responsible property
        };
        this.reEnteredPassword = '';
    }
    
    validateUsername(): void {
        const enteredUsername = this.registerData.userName;

        // Check if username is less than 6 characters
        if (enteredUsername.length < 6) {
            this.usernameError = 'Please enter at least 6 characters.';
            this.usernameValid = ''; // Clear valid message
            return;
        }

        // Check if username is unique
        if (this.allUsernames.includes(enteredUsername)) {
            this.usernameError = 'Username is already taken. Please choose another.';
            this.usernameValid = ''; // Clear valid message
        } else {
            this.usernameError = ''; // Clear error message
            this.usernameValid = 'Username is valid.'; // Show valid message
        }
    }
    onRegisterClick(): void {
        this.submitted = true;
        const email = this.registerData.email.toLowerCase();
        const { userName, firstName, lastName, mobileNumber, password, countryCode, company, division } = this.registerData;

        // Validate required fields
        if (!userName || !firstName || !lastName || !email || !mobileNumber || (!this.editingUserId && !password)) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Missing fields',
                detail: `Please fill in all required fields.`,
                life: 1000
            });
            return;
        }

        // Check if username is unique
        this.validateUsername();
        if (this.usernameError) {
            this.messageService.add({
                severity: 'error',
                summary: 'Username Error',
                detail: 'plz enter valid username',
                life: 3000
            });
            return; // Stop submission if username is not unique
        }

        if (this.editingUserId !== null) {
            // Edit existing user logic
            const index = this.registeredUsers.findIndex((u) => u.id === this.editingUserId);
            if (index !== -1) {
                this.registeredUsers[index] = {
                    id: this.editingUserId,
                    firstName,
                    lastName,
                    email,
                    mobile: mobileNumber,
                    isActive: this.registeredUsers[index].isActive,
                    userName: this.registeredUsers[index].userName // Preserve the existing userName
                };
            }
            this.router.navigate(['/registered-user']); // Navigate to RegisteredUserComponent
        } else {
            console.log(this.registerData.facility);
            console.log(this.registerData.warehouse);

            // Add new user logic
            const payload = {
                userName: userName,
                password: password,
                firstName: firstName,
                middleName: this.registerData.middleName || '',
                lastName: lastName,
                email: email,
                mobile: `${countryCode}${mobileNumber}`,
                status: 'ACTIVE',
                facility: this.registerData.facility,
                warehouse: this.registerData.warehouse,
                company: company,
                division: division,
                m3ResponsibleId: this.registerData.m3ResponsibleId || ''
            };

            //    this.http.post<User[]>(`${environment.authApiUrl}create-cognito-user`, payload).subscribe({
            //   next: () => {
            //     this.registerDialog = false;
            //     const newUser: User = {
            //       id: this.userIdCounter++,
            //       firstName,
            //       lastName,
            //       email,
            //       mobileNumber,
            //       isActive: true,
            //       userName: payload.userName
            //     };
            //     this.registeredUsers.push(newUser);
            //     localStorage.setItem('registeredUsers', JSON.stringify(this.registeredUsers));
            //     this.submitted = false;

            //     this.messageService.add({
            //       severity: 'success',
            //       summary: 'Success',
            //       detail: `${firstName} ${lastName} has been registered.`,
            //       life: 3000
            //     });

            //     this.router.navigate(['/registered-user']);
            //   },
            //   error: (err) => {
            //   let errorMessage = '';

            //   if (typeof err.error === 'string') {
            //     errorMessage = err.error;
            //   } else if (typeof err.message === 'string') {
            //     errorMessage = err.message;
            //   } else {
            //     errorMessage = 'Unknown error';
            //   }

            //   console.log('Error message:', errorMessage);

            //   if (errorMessage.startsWith('Cognito user created and saved locally:')) {
            //     this.registerDialog = false;

            //     this.messageService.add({
            //       severity: 'success',
            //       summary: 'Success (from error)',
            //       detail: `${firstName} ${lastName} has been registered.`,
            //       life: 3000
            //     });

            //     this.router.navigate(['/registered-user']);
            //   } else {
            //     console.error('Failed to create user in Cognito:', err);

            //     this.messageService.add({
            //       severity: 'error',
            //       summary: 'Error',
            //       detail: 'Failed to create user in Cognito',
            //       life: 3000
            //     });
            //   }
            // }

            // });

            this.http
                .post(
                    `${environment.authApiUrl}create-cognito-user`,
                    payload,
                    { responseType: 'text' } // 👈 THIS is the fix
                )
                .pipe(takeUntil(this.destroy$))
                .subscribe({
                    next: (response: string) => {
                        console.log('Raw response:', response);

                        if (response.startsWith('Cognito user created and saved locally:')) {
                            this.registerDialog = false;

                            this.messageService.add({
                                severity: 'success',
                                summary: 'Success',
                                detail: `${firstName} ${lastName} has been registered.`,
                                life: 3000
                            });
                            this.fetchUsers(); 
                            this.router.navigate(['/registered-user']);
                        } else {
                            // Fallback case if some other unexpected text comes
                            this.messageService.add({
                                severity: 'warn',
                                summary: 'Unexpected Response',
                                detail: response,
                                life: 3000
                            });
                        }
                    },
                    error: (err: any) => {
                        console.error('❌ Error Response:', err);

                        let errorMsg = 'Failed to create user in Cognito';
                        let cognitoMsg = '';

                        try {
                            const parsedError = JSON.parse(err.error);

                            errorMsg = parsedError.message || errorMsg;
                            cognitoMsg = parsedError.cognitoMessage || '';

                            // 🔹 Remove the common prefix if present
                            const commonPrefix = 'Password did not conform with password policy:';
                            if (cognitoMsg.startsWith(commonPrefix)) {
                                cognitoMsg = cognitoMsg.replace(commonPrefix, '').trim();
                            }
                        } catch (e) {
                            errorMsg = err.error?.message || errorMsg;
                            cognitoMsg = err.error?.cognitoMessage || '';
                        }

                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: cognitoMsg || errorMsg, // 👈 show cleaned Cognito msg
                            life: 4000
                        });
                    }
                });
        }
    }

    editUser(user: User): void {
        console.log('Editing user:', user);

        this.registerData = {
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            mobileNumber: user.mobile || '',
            password: '', // keep empty, ignore password editing
            userName: user.userName,
            middleName: user.middleName || '',
            status: user.status || '',
            facility: user.facility || '',
            warehouse: user.warehouse || '',
            countryCode: '+91', // or set to user.countryCode if available
            company: user.company || '', // or set to user.company if available
            division: user.division || '' ,// or set to user.division if available
            m3ResponsibleId: user.m3ResponsibleId || '' // or set to user.m3Responsible if available
        };
        this.reEnteredPassword = '';
        this.editingUserId = user.id;
        this.registerDialog = true;
    }

    //  deleteUser(user: User): void {
    //   console.log('Deleting user:', user);
    //   this.confirmationService.confirm({
    //     message: `Are you sure you want to delete ${user.firstName} ${user.lastName}?`,
    //     header: 'Confirm',
    //     icon: 'pi pi-exclamation-triangle',
    //     accept: () => {
    //       this.registeredUsers = this.registeredUsers.filter(u => u.id !== user.id);
    //       localStorage.setItem('registeredUsers', JSON.stringify(this.registeredUsers));
    //       this.messageService.add({
    //         severity: 'success',
    //         summary: 'Deleted',
    //         detail: `${user.firstName} ${user.lastName} has been deleted.`,
    //         life: 3000
    //       });
    //     }
    //   });
    // }

    disableUsers(emails: string[]): Observable<any> {
        const url = `${environment.authApiUrl}disable`;
        const body = { emails };
        return this.http.post<any>(url, body, { responseType: 'text' as 'json' });
    }

disableSelectedUsers(): void {
        if (!this.selectedUsers || this.selectedUsers.length === 0) {
            this.messageService.add({
                severity: 'warn',
                summary: 'No Selection',
                detail: 'Please select at least one user to disable',
                life: 3000
            });
            return;
        }

        const emails = this.selectedUsers.map((user) => user.email);
        this.loaderService.show('Disabling users...');
        this.disableUsers(emails)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Disabled',
                        detail: 'Selected user(s) disabled successfully',
                        life: 3000
                    });
                    this.selectedUsers = [];
                    this.loaderService.hide();
                    // Refresh the user list after disable
                    this.fetchUsers();
                },
                error: (err) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to disable selected user(s)',
                        life: 3000
                    });
                    this.loaderService.hide();
                }
            });
    }


 isDisableButtonDisabled(): boolean {
        if (!this.selectedUsers || this.selectedUsers.length === 0) {
            return true;
        }
        // Disable button should be disabled if all selected users have status "DISABLE" or "DISABLED"
        return !this.selectedUsers.some((user) => 
            user.status?.toUpperCase() !== 'DISABLE' && 
            user.status?.toUpperCase() !== 'DISABLED' &&
            user.isActive !== false
        );
    }
 enableSelectedUsers(): void {
        if (!this.selectedUsers || this.selectedUsers.length === 0) {
            this.messageService.add({
                severity: 'warn',
                summary: 'No Selection',
                detail: 'Please select at least one user to enable',
                life: 3000
            });
            return;
        }

        const emails = this.selectedUsers.map((user) => user.email);
        this.loaderService.show('Enabling users...');
        this.userService.enableUsers(emails)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response) => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Enabled',
                        detail: 'Selected user(s) enabled successfully',
                        life: 3000
                    });
                    this.selectedUsers = [];
                    this.loaderService.hide();
                    // Refresh the user list after enable
                    this.fetchUsers();
                },
                error: (err) => {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to enable selected user(s)',
                        life: 3000
                    });
                    this.loaderService.hide();
                }
            });
    }


   isEnableButtonDisabled(): boolean {
        if (!this.selectedUsers || this.selectedUsers.length === 0) {
            return true;
        }
        // Enable button should be disabled if all selected users have status "ACTIVE" or are already active
        return !this.selectedUsers.some((user) => 
            (user.status?.toUpperCase() === 'DISABLE' || 
             user.status?.toUpperCase() === 'DISABLED' || 
             user.isActive === false)
        );
    }

    searchUsers(event: any): void {
        const query = event.query.toLowerCase();
        this.filteredUsers = this.registeredUsers.filter((user) => `${user.firstName} ${user.lastName}`.toLowerCase().includes(query));
    }

    onGlobalFilter(table: Table, event: Event) {
        table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
    }
    // Inside your component class
    resetPasswordDialog = false;
    resetEmail: string = '';
    resetPasswordSubmitted = false;

    openResetPasswordDialogFromSelection(): void {
        if (this.selectedUsers && this.selectedUsers.length === 1) {
            const selectedUser = this.selectedUsers[0];
            this.resetEmail = selectedUser.email;
            this.resetPasswordSubmitted = false;
            this.resetPasswordDialog = true;
        }
    }

    sendResetLink() {
        this.resetPasswordSubmitted = true;

        if (!this.resetEmail) {
            return; // show validation error
        }

        // Simulate email sending (you can integrate with your API here)
        console.log('Sending reset link to:', this.resetEmail);

        // Close the dialog and show a message (optionally use a toast)
        this.resetPasswordDialog = false;
        alert(`A password reset link has been sent to ${this.resetEmail}`);
    }
    @ViewChild('userNameInput', { read: ElementRef }) userNameInput!: ElementRef;
    @ViewChild('firstNameInput') firstNameInput!: ElementRef;
    @ViewChild('middleNameInput') middleNameInput!: ElementRef;
    @ViewChild('lastNameInput') lastNameInput!: ElementRef;
    @ViewChild('emailInput') emailInput!: ElementRef;
    @ViewChild('countryCodeInput') countryCodeInput!: ElementRef;
    @ViewChild('mobileNumberRawInput') mobileNumberRawInput!: ElementRef;
    @ViewChild('passwordInput', { read: ElementRef }) passwordInput!: ElementRef;
    @ViewChild('statusInput', { read: ElementRef }) statusInput!: ElementRef;
    @ViewChild('facilityInput') facilityInput!: ElementRef;
    @ViewChild('warehouseInput') warehouseInput!: ElementRef;
    @ViewChild('reEnteredPasswordInput', { read: ElementRef }) reEnteredPasswordInput!: ElementRef;
    @ViewChild('registerButton') registerButton!: Button;
    @ViewChild('rowContextMenu') rowContextMenu!: ContextMenu;

    /**
     * Focuses the next element.
     * @param next - either an ElementRef or a PrimeNG Button
     */
    focusNext(next: ElementRef | Button) {
        if (next instanceof Button) {
            // PrimeNG Button -> native button element
            next.el.nativeElement.focus();
        } else if (next && next.nativeElement) {
            next.nativeElement.focus();
        }
    }

    focusStatusInput() {
        this.statusInput?.nativeElement?.focus();
    }
    focusReEnteredPasswordInput() {
        this.reEnteredPasswordInput?.nativeElement?.focus();
    }
    focusUserNameInput() {
        this.userNameInput?.nativeElement?.focus();
    }
    focusPasswordInput() {
        this.passwordInput?.nativeElement?.focus();
    }

    restrictToNumbers(event: KeyboardEvent): void {
        const key = event.key;
        if (!/\d/.test(key) && key !== 'Backspace' && key !== 'Delete') {
            event.preventDefault();
        }
    }

    checkMobileNumberValidity(mobileNumber: string): boolean {
        const regex = /^[6-9][0-9]{9}$/;
        return regex.test(mobileNumber);
    }

    validateMobileNumber() {
        const mobileNumber = this.registerData.mobileNumber;
        const countryCode = this.registerData.countryCode;

        if (countryCode === '+91') {
            const regex = /^[6-9][0-9]{9}$/;
            this.mobileNumberError = regex.test(mobileNumber) ? '' : 'Mobile number must start with digits 6-9 and be exactly 10 digits.';
        } else if (countryCode === '+49') {
            const regex = /^[1-9][0-9]{10,15}$/;
            this.mobileNumberError = regex.test(mobileNumber) ? '' : 'Mobile number must be between 11 and 15 digits.';
        } else if (countryCode === '+31') {
            const regex = /^[1-9][0-9]{8}$/;
            this.mobileNumberError = regex.test(mobileNumber) ? '' : 'Mobile number must be exactly 9 digits.';
        } else {
            this.mobileNumberError = '';
        }
    }


allRoleGroups: any[] = [];
roleGroupOptions = [
  { id: 1, name: 'sales_person_group' },
  { id: 2, name: 'sales_manager_group' },
  { id: 3, name: 'admin_group' },
  { id: 4, name: 'read_only_group' } // Added read_only_group
];
searchRoleGroups(event: any) {
  const query = event.query?.toLowerCase() || '';
  this.roleGroupSuggestions = this.roleGroupOptions.filter((group: any) =>
    group.name.toLowerCase().includes(query)
  );
}
openAssignRoleDialog() {
  if (!this.selectedUsers || this.selectedUsers.length === 0) {
    return;
  }

  this.isLoadingRoles = true;
  this.assignRoleDialog = true;
  this.selectedRoleGroups = [];
  this.roleGroupSuggestions = [...this.roleGroupOptions];

  if (this.selectedUsers.length !== 1) {
    this.isLoadingRoles = false;
    return;
  }

  const selectedUser = this.selectedUsers[0];
  this.http
    .get<any[]>(`${environment.authApiUrl}users/${selectedUser.id}/role-groups`)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (groups) => {
        this.selectedRoleGroups = this.getPreselectedRoleGroups(groups || []);
        this.isLoadingRoles = false;
      },
      error: () => {
        this.selectedRoleGroups = [];
        this.isLoadingRoles = false;
        this.messageService.add({
          severity: 'warn',
          summary: 'Role fetch issue',
          detail: 'Could not load existing role groups. You can still assign roles manually.',
          life: 4000
        });
      }
    });
}

private getRoleId(role: any): number | null {
  const rawId = role?.id ?? role?.roleGroupId ?? null;
  if (rawId === null || rawId === undefined) {
    return null;
  }
  const parsed = Number(rawId);
  return Number.isNaN(parsed) ? null : parsed;
}

private getPreselectedRoleGroups(existingGroups: any[]): any[] {
  const existingIds = new Set(
    existingGroups
      .map((group) => this.getRoleId(group))
      .filter((id): id is number => id !== null)
  );
  const existingNames = new Set(
    existingGroups
      .map((group) => (group?.name || '').toString().toLowerCase().trim())
      .filter((name) => !!name)
  );

  return this.roleGroupOptions.filter((roleOption: any) => {
    const optionId = this.getRoleId(roleOption);
    const optionName = (roleOption?.name || '').toString().toLowerCase().trim();
    const byId = optionId !== null && existingIds.has(optionId);
    const byName = !!optionName && existingNames.has(optionName);
    return byId || byName;
  });
}
// assignRoleGroups() {
//   if (!this.selectedUsers.length || !this.selectedRoleGroups.length) return;
//   const usernames = this.selectedUsers.map((u: any) => u.username || u.userName || u);
//   const roleGroupIds = this.selectedRoleGroups.map((g: any) => g.id);

//   this.http.post(`${environment.authApiUrl}assign-role-groups`, {
//     usernames,
//     roleGroupIds
//   }, { responseType: 'text' }).pipe(takeUntil(this.destroy$)).subscribe({
//     next: (response: string) => {
//       this.messageService.add({
//         severity: 'success',
//         summary: 'Success',
//         detail: response, // Show API response here
//         life: 10000
//       });
//       this.assignRoleDialog = false;
//     },
//     error: (err) => {
//       // Try to show error message from API if available
//       const detail = typeof err.error === 'string' && err.error
//         ? err.error
//         : 'Failed to assign role group(s).';
//       this.messageService.add({
//         severity: 'error',
//         summary: 'Error',
//           life: 5000,
//         detail
//       });
//       this.assignRoleDialog = false;
//     }
    // openAssignRoleDialog() {
    //     this.assignRoleDialog = true;
    //     this.selectedRoleGroups = [];
    //     this.roleGroupSuggestions = [...this.roleGroupOptions];
    // }
    assignRoleGroups() {
        if (!this.selectedUsers.length || !this.selectedRoleGroups.length) return;
        const usernames = this.selectedUsers.map((u: any) => u.username || u.userName || u);
        const roleGroupIds = Array.from(
            new Set(
                this.selectedRoleGroups
                    .map((group: any) => this.getRoleId(group))
                    .filter((id): id is number => id !== null)
            )
        );

        if (!roleGroupIds.length) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Could not determine selected role group ids.',
                life: 3000
            });
            return;
        }

        this.http
            .post(
                `${environment.authApiUrl}assign-role-groups`,
                {
                    usernames,
                    roleGroupIds
                },
                { responseType: 'text' }
            )
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: string) => {
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: response, // Show API response here
                        life: 10000
                    });
                    this.assignRoleDialog = false;
                },
                error: (err) => {
                    // Try to show error message from API if available
                    const detail = typeof err.error === 'string' && err.error ? err.error : 'Failed to assign role group(s).';
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        life: 5000,
                        detail
                    });
                    this.assignRoleDialog = false;
                }
            });
    }

    // === Remove Role Group ===
    removeRoleDialog = false;
    userRoleGroupsForSelected: any[] = [];
    selectedRoleGroupsToRemove: any[] = [];
    /** User chosen from row context menu for Remove Role */
    private userForRemoveRole: User | null = null;

    rowContextMenuItems = [
        {
            label: 'Remove Role',
            icon: 'pi pi-minus',
            command: () => {
                if (this.userForRemoveRole) {
                    this.openRemoveRoleForUser(this.userForRemoveRole);
                }
            }
        }
    ];

    onRowContextMenu(event: MouseEvent, user: User): void {
        event.preventDefault();
        this.userForRemoveRole = user;
        this.rowContextMenu.show(event);
    }

    /** Open Remove Role popup for the given user (e.g. from row context menu). */
    openRemoveRoleForUser(user: User): void {
        this.selectedUsers = [user];
        this.openRemoveRoleDialog();
    }

    openRemoveRoleDialog(): void {
        if (!this.selectedUsers || this.selectedUsers.length !== 1) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Select one user',
                detail: 'Please select exactly one user to remove role groups.',
                life: 3000
            });
            return;
        }

        const user = this.selectedUsers[0];
        const userId = user.id;

        this.loaderService.show('Loading assigned role groups...');
        this.http
            .get<any[]>(`${environment.authApiUrl}users/${userId}/role-groups`)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (groups) => {
                    this.userRoleGroupsForSelected = groups || [];
                    this.selectedRoleGroupsToRemove = [];
                    this.removeRoleDialog = true;
                    this.loaderService.hide();
                },
                error: (err) => {
                    console.error('Failed to load role groups for user', err);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to load role groups for selected user.',
                        life: 3000
                    });
                    this.loaderService.hide();
                }
            });
    }

    confirmRemoveSelectedRoleGroup(): void {
        if (!this.selectedUsers || this.selectedUsers.length !== 1 || !this.selectedRoleGroupsToRemove.length) {
            return;
        }

        const user = this.selectedUsers[0];
        const userId = user.id;
        const roleGroupIds = Array.from(
            new Set(
                this.selectedRoleGroupsToRemove
                    .map((group: any) => group.id ?? group.roleGroupId ?? null)
                    .filter((id: number | null) => id != null)
            )
        );

        if (!roleGroupIds.length) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Could not determine selected role group ids.',
                life: 3000
            });
            return;
        }

        this.loaderService.show('Removing role group(s)...');
        const deleteRequests = roleGroupIds.map((roleGroupId) =>
            this.http
                .delete(`${environment.authApiUrl}users/${userId}/role-groups/${roleGroupId}`, {
                    responseType: 'text'
                })
                .pipe(
                    map(() => ({ roleGroupId, success: true })),
                    catchError((error) => of({ roleGroupId, success: false, error }))
                )
        );

        forkJoin(deleteRequests)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (results) => {
                    const removedIds = results.filter((result) => result.success).map((result) => result.roleGroupId);
                    const failedCount = results.length - removedIds.length;

                    if (removedIds.length) {
                        this.userRoleGroupsForSelected = this.userRoleGroupsForSelected.filter(
                            (group: any) => !removedIds.includes(group.id ?? group.roleGroupId)
                        );
                    }

                    this.selectedRoleGroupsToRemove = [];

                    if (removedIds.length) {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Role group(s) removed',
                            detail: `${removedIds.length} role group(s) removed successfully.`,
                            life: 4000
                        });
                    }

                    if (failedCount) {
                        this.messageService.add({
                            severity: 'warn',
                            summary: 'Some removals failed',
                            detail: `${failedCount} role group(s) could not be removed.`,
                            life: 4000
                        });
                    }

                    this.loaderService.hide();
                },
                error: (err) => {
                    console.error('Failed to remove role group', err);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to remove selected role group.',
                        life: 3000
                    });
                    this.loaderService.hide();
                }
            });
    }

    ngOnDestroy(): void {
        // Signal all observables to complete and clean up subscriptions
        this.destroy$.next();
        this.destroy$.complete();
        console.log('RegisteredUserComponent destroyed');
    }
}
